import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  styled,
  ListItemButton,
  ListItemText,
  Collapse,
  IconButton,
} from '@mui/material';

export const ExpandMoreStyled = styled(ExpandMore)(() => ({}));
export const ExpandLessStyled = styled(ExpandLess)(() => ({}));
export const CollapseStyled = styled(Collapse)(() => ({
  display: 'block',
  '.MuiCollapse-wrapper': {
    display: 'block',
  },
}));

export const IconButtonStyled = styled(IconButton)(() => ({
  padding: 0,
}));

export const ListItemTextStyled = styled(ListItemText)(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fonts.default.bold.fontFamily,
  fontWeight: theme.fonts.default.bold.fontWeight,
}));
export const ListItemButtonStyled = styled(ListItemButton, {
  shouldForwardProp: (prop) =>
    !['level', 'openLocal', 'secondaryAction'].includes(prop as string),
})(({ theme, level, openLocal }) => ({
  padding: 0,
  height: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  paddingRight: `${theme.spacings.unit(36 / 4)}`,
  paddingLeft: `${theme.spacings.unit(36 / 4 + (20 / 4) * level)}`,
  // Ugly
  // backgroundColor: (() => {
  //   switch (true) {
  //     case level === 1 && openLocal:
  //       return '#E30813';
  //     case level === 2 && openLocal:
  //       return '#e308133b';
  //     case level === 3 && openLocal:
  //       return '#e3081321';
  //     default:
  //       return 'inherit';
  //   }
  // })(),
  // color: (() => {
  //   switch (true) {
  //     case level === 1 && openLocal:
  //       return 'white';
  //     default:
  //       return 'inherit';
  //   }
  // })(),
  // 'a': {
  //   color: (() => {
  //     switch (true) {
  //       case level === 1 && openLocal:
  //         return 'white';
  //       default:
  //         return 'inherit';
  //     }
  //   })()
  // }
}));
export const ListItemOnClickCaptureStyled = styled('a')(({ theme }) => {
  return {
    height: '100%',
    display: 'inline-block',
    color: `${theme?.colors?.primaryText || ''}`,
    cursor: 'pointer',
    textDecoration: 'none',
    paddingBottom: `${theme.spacings.unit(12 / 4)}`,
    paddingTop: `${theme.spacings.unit(12 / 4)}`,
    fontFamily: theme.fonts.default.bold.fontFamily,
    fontWeight: theme.fonts.default.bold.fontWeight,
  };
});
